<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-04-01 17:41:45
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-04-13 15:09:47
-->
<template>
  <div class="serviceIncomeCell">
    <div>
      <div>团长服务费率：{{ row.income_commission_rate }}%</div>
      <div>预估收入：￥{{ row.income_estimated_commission }}</div>
      <div>实际收入：￥{{ row.income_real_commission }}</div>
    </div>
  </div>
</template>
<script>
import mixin from './mixin'
export default {
  mixins: [mixin]
}
</script>
